import { Tabs, Upload, Button, message } from 'antd';
import { useTranslation } from 'react-i18next';
import { apiUrl } from '../../settings/settings';
import { UploadOutlined } from '@ant-design/icons';
import { PageHeader } from '../../components/PageHeader';
import { ExportWcoXmlWebConfig } from './components/ExportWcoXmlWebConfig';
import { WcoXmlWebAnalyticsTabContent } from './components/WcoXmlWebAnalyticsTabContent';
import { useCompanyData } from './useCompanyData';
import { Loader } from '../../components/Loader';
import { useSelector } from 'react-redux';
import { getUserRoles } from '../../redux/auth/selectors';
import { useNavigate } from 'react-router-dom';

export const WcoXmlWebAnalytics = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const userRoles = useSelector(getUserRoles);
  const { companyData, loading } = useCompanyData();
  const companyDhlNo = [];
  const tabs = [];

  const props = {
    name: 'file',
    action: apiUrl + 'wcoxml_web/:companyId/import',
    multiple: true,
    headers: {
      Authentication: `Bearer ${localStorage.getItem('token')}`,
      'x-api-key': 'SfCN4KQD3rhdU3zDdM9VKpNe',
    },
    // beforeUpload: file => {
    //   const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    //   if (!isExcel) {
    //     message.error(`${file.name} is not a correct XLSX file`);
    //   }
    //   return isExcel || Upload.LIST_IGNORE;
    // },
    onChange(info) {
      if (info.file.status === 'done') {
        message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
      }
      return Upload.LIST_IGNORE;
    },
  };

  const uploadButton = () => {
    if (userRoles.indexOf('admin') != -1) {
      return (
        <>
          <Upload {...props}>
            <Button icon={<UploadOutlined />}>{t('myCompanies.import')}</Button>
          </Upload>
          <ExportWcoXmlWebConfig companyData={companyData} />
        </>
      );
    }
    return <></>;
  };

  if (companyData) {
    let analyticsData = {};
    companyData.data.forEach(row => {
      let dhlId = parseInt(row.dhl_id);
      let date = row.date.substring(0, 10);

      if (!analyticsData[dhlId]) {
        analyticsData[dhlId] = {};
      }

      if (!analyticsData[dhlId][date]) {
        analyticsData[dhlId][date] = {
          date: date,
          global_processed: 0,
          fields_processed: 0,
          line_items_processed: 0,
          WAW: 0,
          OZR: 0,
          WRO: 0,
          GDN: 0,
          POZ: 0,
          SZZ: 0,
          KTW: 0,
          IMPORT: 0,
          EXPORT: 0,
          count: 0,
        };
      }

      analyticsData[dhlId][date]['global_processed'] += row.fields_processed ?? 0;
      analyticsData[dhlId][date]['global_processed'] += row.global_processed ?? 0;
      analyticsData[dhlId][date]['line_items_processed'] += row.line_items_processed ?? 0;
      analyticsData[dhlId][date]['count']++;
      analyticsData[dhlId][date][row.source]++;
      analyticsData[dhlId][date][row.way]++;
    });

    let dhlIds = companyData.company.dhl_ids;
    for (let f = 0; f < dhlIds.length; f++) {
      let singleDhlNo = parseInt(dhlIds[f]);
      tabs.push({
        key: singleDhlNo,
        label: singleDhlNo,
        children: <WcoXmlWebAnalyticsTabContent data={analyticsData[singleDhlNo]} />,
      });
    }
  }

  return (
    <>
      <PageHeader
        titleTranslationKey='companies.wcoxmlweb_analytics'
        onBack={() => navigate('/front/companies')}
        extra={uploadButton()}
      />
      <Loader loading={loading}>
        <Tabs defaultActiveKey={companyDhlNo[0]} items={tabs} />
      </Loader>
    </>
  );
};
